import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { i18nConfig } from './assets/lang/i18nConfig';

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: i18nConfig,
        lng: localStorage.getItem('lang') || 'vi',
        fallbackLng: 'vi',
        ns: Object.keys(i18nConfig.vi),
        defaultNS: 'translation',
        interpolation: {
            escapeValue: false // react already safes from xss
        },
        react: {
            useSuspense: false,
        }
    });

export default i18n;